import axios from './userInstance'

const USER_API_URL = import.meta.env.VITE_API_URL_USER

export const getCompanyUserLinkEndpoint = (companyId: string) => (
    `${USER_API_URL.replace(/\/$/, '')}/v2/companies/${encodeURIComponent(companyId)}/users/link`
)

const linkUserToCompany = async (email: string, companyId: string) => {
    const response = await axios.post(
        getCompanyUserLinkEndpoint(companyId),
        {email},
    )
    return response.data
}

export default linkUserToCompany
